<div class="row text-center">
  <div *ngIf="loadingRequired" class="col-2">
    <mat-progress-spinner class="text-center" diameter="30" strokeWidth="3" mode="indeterminate">
    </mat-progress-spinner>
  </div>
  <div class="col-10">
    {{ data?.message | translate }}
  </div>
  <div *ngIf="!loadingRequired" class="col-2"><i class="bi bi-x"></i></div>
</div>
